import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_BASE_URL_REFRESH_LAMBDA_KEY
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_REFRESH_LAMBDA,
  headers: { ...header }
})